module.exports = __webpack_public_path__ + "na.svg?9cc16b5c9032067fc8d869bc5cf0fb3f";